<template>
  <div class="hello">
    <div class="box-3">
      <div class="sub-title">专业在线咨询，解决办公困扰</div>
      <div class="title-txt">全方位多角度的在线咨询</div>
    </div>
    <div>
      <div class="btn-flex">
        <div class="btn1" @click="clickSY">立即体验</div>
        <div class="btn2" @click="clickZX1">企业咨询</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="content">
        <div class="left">
            <div class="all">
                <div class="title" >解决方案</div>
                <div class="service" @click="jumps1">钉钉专业版</div>
                <div class="service" @click="jumps2">钉钉专属版</div>
                <div class="service" @click="jumps3">Teambition</div>
            </div>
            <div class="all">
                <div class="title" >产品服务</div>
                <!-- <div class="service" @click="jumps5">钉闪会</div> -->
                <div class="service" @click="jumps6">宜搭</div>
                <div class="service" @click="jumps8">氚云</div>
                <div class="service" @click="jumps7">云枢</div>
                <div class="service" @click="jumps4">定制工作台</div>
                <div class="service" @click="jumps9">智能硬件</div>


            </div>
            <div class="all">
                <div class="title" >企业概况</div>
                <div class="service" @click="jumps10">关于我们</div>
                <div class="service" @click="jumps11">加入我们</div>

            </div>
        </div>
        <div class="center">
            <div class="all">
                <div class="title">全国统一服务热线</div>
                <div class="about" style="display: flex;align-items: center">
                  <img src="../views/img-12-30/tel.png" alt="">
                  <div class="email" style="margin-left: 10px;">182-0508-0131</div>
                </div>
              <div class="title">客服服务时段</div>
                <div class="about">

                    <div class="email">周一至周日，9:00-21:00，节假日不休息</div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="left-img">
                <div class="img">
                    <img src="../views/img-12-30/weixin.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="buttom">
        <span class="span1" @click="spanHhome">南京壹宝通信息技术有限公司</span>
        <span class="span2 span-ssad" @click="Beian">苏ICP备2022042997号</span>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        spanHhome(){
            this.$router.push({name:"home"})
        },
        Beian(){
            window.open('https://beian.miit.gov.cn/#/Integrated/index')
        },
        alall(){
            window.open('dingtalk://dingtalkclient/page/link?pc_slide=true&url=https%3A%2F%2Fh5.dingtalk.com%2F40plan%2Fappoint-custom%2Findex.html%3FinviteCode%3DP99001E93001%26expertSelectdDeptId%3D78752071%26expertDingtalkTetantStafffId%3D01325352847243%26goodName%3D%26articleCode%3D%26showmenu%3Dfalse%23%2Fopportunity-order')
        },
        clickJumpShiyong(){
            this.$router.push({name:"shiyong"})
        },
        jumps1(){
            this.$router.push({name:"major"})
        },
        jumps2(){
            this.$router.push({name:"onlyDingding"})
        },
        jumps3(){
            this.$router.push({name:"teamB"})
        },
        jumps4(){
            this.$router.push({name:"onlyWork"})
        },
        jumps5(){
            this.$router.push({name:"dingFlash"})
        },
        jumps6(){
            this.$router.push({name:"yida"})
        },
        jumps7(){
            this.$router.push({name:"yunshu"})
        },
        jumps8(){
            this.$router.push({name:"chuanyun"})
        },
        jumps9(){
            this.$router.push({name:"dingConnect"})
        },
        jumps10(){
            this.$router.push({name:"aboutUs"})
        },
        jumps11(){
            this.$router.push({name:"talentPeople"})
        },
      clickSY(){
        window.open('https://isite.baidu.com/site/wjzkc6f4/53b343e9-93a8-4fff-8b41-80c73584960d')
      },
      clickZX1(){
        window.open('https://ada.baidu.com/site/wjzkc6f4/agent?imid=5d91d676c2c61e803f929d52269380db&showpageinpc=1')
      }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped >
.hello{
  width: 100%;
  height: 62rem;
  background: linear-gradient(180deg, rgba(235, 244, 255, 1) 0%, rgba(245, 251, 255, 0.5) 100%);
  >.content{
      width: 85%;
      margin: auto;
      padding: 35px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding: 50px;
      >.left{
          width: 45%;
          display: flex;
          justify-content: space-between;
          >.all{
              text-align: left;
              padding: 0px 35px;
              >.title{
                    font-size: 32px;
                    color: #111;
                    font-weight: bold;
                    margin: 15px 0 32px 0;
                    letter-spacing: 2px;
              }
              >.service{
                    font-size: 24px;
                    color: #a9a9a9;
                    cursor: pointer;
                    margin: 15px 0;
              }
              .service:hover{
                color: #111;
              }
          }
      }
      >.center{
          width: 30%;
          display: flex;
          justify-content: space-between;
          >.all{
              width: 100%;
              text-align: left;
              padding: 0px 40px;
                >.title{
                        font-size: 32px;
                        color: #111;
                        font-weight: bold;
                        margin: 15px 0 15px 0;
                        letter-spacing: 2px;
                }
                >.about{
                    font-size: 24px;
                    color: #a9a9a9;
                    margin-bottom:20px ;
                    line-height: 1.5;
                    letter-spacing: 1px;
                    >.address{
                        font-weight: bold;
                    }
                }
          }
      }
      >.right{
          width: 15%;
          display: flex;
          justify-content: space-around;
          //padding: 0px 40px;
          >.left-img{
              padding: 15px 0;
            //   display: flex;
            //   justify-content: center;
            //   flex-wrap: wrap;
              >.img{
                  width: 285px;
                  height: 285px;
                  >img{
                        width: 100%;
                        height: 100%;
                  }
              }
              >.title{
                  width: 100%;
                //   height: 30px;
                  color: #fff;
                  font-size: 24px;
                  font-weight: bold;
                  text-align: left;
                  margin-top: 20px;
              }
              >p{
                  font-size: 16px;
                  color: #a9a9a9;
                  text-align: left;
                  margin-top: 15px;
              }
              >.watch{
                  color: #4790d4;
                  font-size: 12px;
                  text-align: left;
                  margin-top: 15px;
                  cursor: pointer;
              }
              .watch:hover{
                text-decoration: underline;
              }
          }

      }
    }
     >.buttom{
      background-color: black;
      width: 100%;
      padding: 20px;
      >span{
          color: #aaaaaa;
          font-size: 16px;
      }
      .span-ssad:hover{
            color: rgb(0,137,255);
        }
    }
  .box-3 {
    width: 100%;
    height: 340px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 26px;
    .sub-title{
      font-size: 79px;
      font-weight: 500;
      letter-spacing: 2px;
      margin: 1rem 0 1rem 0;
      padding: 0 3rem;
    }
    .title-txt{
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.6);
      margin-top: 20px;
    }
  }
  .btn1{
    width: 212px;
    height: 66px;
    line-height: 66px;
    border-radius: 6px;
    background: rgba(0, 137, 255, 1);
    color: rgba(255, 255, 255, 1);
    margin: 80px 40px 0 0;
    cursor: pointer;

  }
  .btn2{
    width: 212px;
    height: 66px;
    line-height: 66px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
    border: 2px solid rgba(0, 137, 255, 1);
    color: rgba(0, 137, 255, 1);
    margin: 80px 40px 0 0;
    cursor: pointer;
  }
  .btn-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
  .line {
    height: 1px;
    width: 85%;
    background:rgba(0, 0, 0, 0.1);
    margin: 40px auto;
  }
}
.span1{
    margin-right: 30px;
    cursor: pointer;
}
.span2{
    cursor: pointer;
    color: #000;
}

</style>

